import Launch from "@mui/icons-material/Launch";
import Chip from "@mui/joy/Chip";
import Link from "@mui/joy/Link";
import { Subject } from "../../../models/cohort";
import UnifiedDataTable, { DataTableColumn } from "../../../shared/components/ui/UnifiedDataTable";

interface PatientTableProps {
  readonly subjects: Subject[];
}

export default function PatientsTable({ subjects }: PatientTableProps) {
  const columns: DataTableColumn<Subject>[] = [
    {
      key: "patient_id",
      header: "Patient ID",
      width: "320px",
      render: (subject) => (
        <Link
          underline="hover"
          href={"/patient/" + subject.person_source_value}
          target="_blank"
          rel="noopener"
          endDecorator={<Launch fontSize="small" />}
        >
          {subject.person_source_value}
        </Link>
      ),
    },
    {
      key: "entry_date",
      header: "Entry date",
      render: (subject) => subject.entry_date,
    },
    {
      key: "status",
      header: "Status",
      render: (subject) => (
        <Chip color={subject.inactive ? "warning" : "success"}>
          {subject.inactive ? "Excluded" : "Included"}
        </Chip>
      ),
    },
  ];

  return (
    <UnifiedDataTable
      data={subjects}
      columns={columns}
      getItemId={(subject) => subject.person_id.toString()}
      pageSize={25}
      paginationThreshold={25}
      ariaLabel="patient cohort table"
    />
  );
}
